import { useEffect } from 'react';

const updateOrCreateMeta = (name, content, attribute = 'name') => {
  if (!content) return;
  let element = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const updateOrCreateLink = (rel, href) => {
  if (!href) return;
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

/**
 * SEO Component for dynamic meta tags and JSON-LD schema injection
 */
const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage = 'https://wrapyourwish.com/logo_new.png',
  ogType = 'website',
  schemas = [],
}) => {
  useEffect(() => {
    // 1. Update Title
    if (title) {
      document.title = title;
    }

    // 2. Primary Meta Tags
    if (description) {
      updateOrCreateMeta('description', description);
    }
    if (keywords) {
      updateOrCreateMeta('keywords', keywords);
    }

    // 3. Canonical Link
    const currentUrl = canonicalUrl || window.location.href;
    updateOrCreateLink('canonical', currentUrl);

    // 4. Open Graph Tags
    updateOrCreateMeta('og:title', title || document.title, 'property');
    updateOrCreateMeta('og:description', description, 'property');
    updateOrCreateMeta('og:url', currentUrl, 'property');
    updateOrCreateMeta('og:type', ogType, 'property');
    updateOrCreateMeta('og:image', ogImage, 'property');
    updateOrCreateMeta('og:site_name', 'WrapYourWish', 'property');
    updateOrCreateMeta('og:locale', 'en_IN', 'property');

    // 5. Twitter Card Tags
    updateOrCreateMeta('twitter:card', 'summary_large_image');
    updateOrCreateMeta('twitter:title', title || document.title);
    updateOrCreateMeta('twitter:description', description);
    updateOrCreateMeta('twitter:image', ogImage);

    // 6. Inject dynamic JSON-LD schemas
    const scriptElements = [];
    if (Array.isArray(schemas) && schemas.length > 0) {
      schemas.forEach((schema, idx) => {
        if (!schema) return;
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.className = 'wyw-dynamic-schema';
        script.setAttribute('data-schema-id', `schema-${idx}`);
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
        scriptElements.push(script);
      });
    }

    // Cleanup on unmount or before next effect
    return () => {
      scriptElements.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [title, description, keywords, canonicalUrl, ogImage, ogType, schemas]);

  return null;
};

export default SEO;
